import * as types from "./types";
import { ResponseErrorState } from "@stores/ui/responseError/types";

export const fetchJIRITSUKUNRENSEIKATSUDailyStarted = () =>
  ({ type: types.FETCH_JIRITSUKUNRENSEIKATSU_DAILY_STARTED } as const);
export const fetchJIRITSUKUNRENSEIKATSUDaily = (
  res: types.InOutReportState["reports"]
) => ({ type: types.FETCH_JIRITSUKUNRENSEIKATSU_DAILY, payload: res } as const);
export const fetchJIRITSUKUNRENSEIKATSUDailyFailed = (err: {
  error: { response: ResponseErrorState };
}) =>
  ({
    type: types.FETCH_JIRITSUKUNRENSEIKATSU_DAILY_FAILED,
    error: err
  } as const);

export const fetchJIRITSUKUNRENSEIKATSUUserStarted = () =>
  ({ type: types.FETCH_JIRITSUKUNRENSEIKATSU_USER_STARTED } as const);
export const fetchJIRITSUKUNRENSEIKATSUUser = (
  res: types.InOutReportState["reports"]["reportUser"]
) => ({ type: types.FETCH_JIRITSUKUNRENSEIKATSU_USER, payload: res } as const);
export const fetchJIRITSUKUNRENSEIKATSUUserFailed = (err: {
  error: { response: ResponseErrorState };
}) =>
  ({
    type: types.FETCH_JIRITSUKUNRENSEIKATSU_USER_FAILED,
    error: err
  } as const);

export const fetchDailySummaryStarted = () =>
  ({ type: types.FETCH_JIRITSUKUNRENSEIKATSU_DAILY_SUMMARY_STARTED } as const);
export const fetchDailySummary = (res: types.InOutReportState["summary"]) =>
  ({
    type: types.FETCH_JIRITSUKUNRENSEIKATSU_DAILY_SUMMARY,
    payload: res
  } as const);
export const fetchDailySummaryFailed = (err: {
  error: { response: ResponseErrorState };
}) =>
  ({
    type: types.FETCH_JIRITSUKUNRENSEIKATSU_DAILY_SUMMARY_FAILED,
    error: err
  } as const);
export const unsetJIRITSUKUNRENSEIKATSUDailySummary = () =>
  ({ type: types.UNSET_JIRITSUKUNRENSEIKATSU_DAILY_SUMMARY } as const);

export const fetchJIRITSUKUNRENSEIKATSUUserSummaryStarted = () =>
  ({ type: types.FETCH_JIRITSUKUNRENSEIKATSU_USER_SUMMARY_STARTED } as const);
export const fetchJIRITSUKUNRENSEIKATSUUserSummary = (
  res: types.InOutReportState["summary"]
) =>
  ({
    type: types.FETCH_JIRITSUKUNRENSEIKATSU_USER_SUMMARY,
    payload: res
  } as const);
export const fetchJIRITSUKUNRENSEIKATSUUserSummaryFailed = (err: {
  error: { response: ResponseErrorState };
}) =>
  ({
    type: types.FETCH_JIRITSUKUNRENSEIKATSU_USER_SUMMARY_FAILED,
    error: err
  } as const);

export const putJIRITSUKUNRENSEIKATSUReportStarted = () =>
  ({ type: types.PUT_JIRITSUKUNRENSEIKATSU_REPORT_STARTED } as const);
export const putJIRITSUKUNRENSEIKATSUReportDaily = (
  req: types.InOutReportState["reports"]["reportDaily"]["reportList"]
) =>
  ({
    type: types.PUT_JIRITSUKUNRENSEIKATSU_REPORT_DAILY,
    payload: req
  } as const);
export const putJIRITSUKUNRENSEIKATSUReportUser = (
  req: types.InOutReportState["reports"]["reportUser"]["reportList"]
) =>
  ({
    type: types.PUT_JIRITSUKUNRENSEIKATSU_REPORT_USER,
    payload: req
  } as const);
export const putJIRITSUKUNRENSEIKATSUReportFailed = (err: {
  error: { response: ResponseErrorState };
}) =>
  ({
    type: types.PUT_JIRITSUKUNRENSEIKATSU_REPORT_FAILED,
    error: err
  } as const);

export const postJIRITSUKUNRENSEIKATSUInOutAllRecordStarted = () =>
  ({
    type: types.POST_JIRITSUKUNRENSEIKATSU_IN_OUT_ALL_REPORT_STARTED
  } as const);
export const postJIRITSUKUNRENSEIKATSUInOutAllRecord = (
  req: types.InOutReportState["reports"]["additionsDaily"]
) =>
  ({
    type: types.POST_JIRITSUKUNRENSEIKATSU_IN_OUT_ALL_REPORT,
    payload: req
  } as const);
export const postJIRITSUKUNRENSEIKATSUInOutAllRecordFailed = (err: {
  error: { response: ResponseErrorState };
}) =>
  ({
    type: types.POST_JIRITSUKUNRENSEIKATSU_IN_OUT_ALL_REPORT_FAILED,
    error: err
  } as const);

export const unsetJIRITSUKUNRENSEIKATSUReport = () =>
  ({ type: types.UNSET_JIRITSUKUNRENSEIKATSU_REPORT } as const);

export type ActionTypes =
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUDailyStarted>
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUDaily>
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUDailyFailed>
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUUserStarted>
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUUser>
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUUserFailed>
  | ReturnType<typeof fetchDailySummaryStarted>
  | ReturnType<typeof fetchDailySummary>
  | ReturnType<typeof fetchDailySummaryFailed>
  | ReturnType<typeof unsetJIRITSUKUNRENSEIKATSUDailySummary>
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUUserSummaryStarted>
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUUserSummary>
  | ReturnType<typeof fetchJIRITSUKUNRENSEIKATSUUserSummaryFailed>
  | ReturnType<typeof putJIRITSUKUNRENSEIKATSUReportStarted>
  | ReturnType<typeof putJIRITSUKUNRENSEIKATSUReportDaily>
  | ReturnType<typeof putJIRITSUKUNRENSEIKATSUReportFailed>
  | ReturnType<typeof putJIRITSUKUNRENSEIKATSUReportUser>
  | ReturnType<typeof postJIRITSUKUNRENSEIKATSUInOutAllRecordStarted>
  | ReturnType<typeof postJIRITSUKUNRENSEIKATSUInOutAllRecord>
  | ReturnType<typeof postJIRITSUKUNRENSEIKATSUInOutAllRecordFailed>
  | ReturnType<typeof unsetJIRITSUKUNRENSEIKATSUReport>;
